module.exports = __webpack_public_path__ + "img/step08_c_basket_basic_insert_rear_cross.4762815b.png";